import createReducer from '../../../data/shared/createReducer';
import { UPDATE_QUOTATIONS_FILTERS, REQUEST_QUOTATIONS, RECEIVE_QUOTATIONS, FAILURE_QUOTATIONS, UNLOAD_QUOTATIONS } from '../constants/action_types';
import {followup} from '../../../data/followup/constants/action_types';
import { isEmpty } from "lodash";
import reverse from "lodash/reverse";
import moment from "moment";
import omit from "lodash/omit";

const initialState = {
    isFetching: false,
    isDeleting: false,
    entities: {
        quotations: {},
        services: {},
    },
    nextPage: 0,
    reachedEnd: false,
    filters: {
        route: null,
        date: {
            from: moment().startOf('year').toDate(),
            to: moment().endOf('year').toDate()
        },
        query: null,
        status : []
    }
};

const updateFilters = (state, action) => ({
    ...state,
    filters: {
        ...state.filters,
        ...action.filters
    },
    nextPage: 0,
    reachedEnd : false
})

const failureQuotations = (state, action) => ({
    ...state,
    isFetching: false,
    entities: {
        quotations: {
            error: "error"
        }
    }
})

const receiveQuotations = (state, action) => {

    let quotations = {}
    let services = {}

    if(action.reset && !isEmpty(action.data.entities)){
        quotations = action.data.entities.reservations
        services = action.data.entities.services
    } else if(!action.reset) {
        quotations = {
            ...state.entities.quotations,
            ...action.data.entities.reservations
        }
        services = {
            ...state.entities.services,
            ...action.data.entities.services
        }
    }

    return {
        ...state,
        isFetching: false,
        nextPage: state.nextPage + 1,
        reachedEnd: isEmpty(action.data.entities.reservations),
        entities : {
            quotations,
            services
        }
    }
}

const requestQuotations = (state, action) => {
    return {
        ...state,
        isFetching: true,
        nextPage: action.reset ? 0 : state.nextPage
    }
}

const unloadQuotations = () => ({
    ...initialState
})

const cancelAction = (state, action) => ({
    ...state,
    isDeleting: action.isQuotation ? action.reference : null
});

const failureCancel = (state, action) => ({
    ...state,
    isDeleting: false,
    error : "error cancel"
});

const successCancel = (state, action) => {
    if(state.isDeleting) {
        return {
            ...refreshEntities(state, action),
            isDeleting: false
        }
    }
    return {
        ...state,
        isDeleting: false,
    }
};

const refreshEntities = (state, action) => {
    const quotationId = action.data.result;
    const quotation = action.data.entities.reservations[quotationId];

    return {
        ...state,
        entities: {
            quotations: {
                ...state.entities.quotations,
                [quotationId]: {
                    ...state.entities.quotations[quotationId],
                    ...quotation,
                    history: reverse(quotation.history)
                }
            },
            services: {
                ...state.entities.services,
                ...action.data.entities.services
            }
        }
    };
};

const deleteDraftSuccess = (state, action) => {
    const quotations = omit(state.entities.quotations, action.id);

    return {
        ...state,
        entities: {
            ...state.entities,
            quotations
        }
    }
}

const reservation = createReducer(initialState, {
    [UPDATE_QUOTATIONS_FILTERS]: updateFilters,
    [FAILURE_QUOTATIONS]: failureQuotations,
    [RECEIVE_QUOTATIONS]: receiveQuotations,
    [REQUEST_QUOTATIONS]: requestQuotations,
    [UNLOAD_QUOTATIONS]: unloadQuotations,
    [followup.CANCEL_ACTION]: cancelAction,
    [followup.FAILURE_CANCEL]: failureCancel,
    [followup.SUCCESS_CANCEL]: successCancel,
    [followup.DELETE_DRAFT_SUCCESS]: deleteDraftSuccess,
});

export default reservation;